// import styled from 'styled-components'
// import {Box} from 'rebass'
// const ChatBubbleWrapper = styled(Box)
export default {
  chatbubbleWrapper: {
    marginTop: 10,
    marginBottom: 10,
    overflow: 'auto',
    position: 'relative',
    maxWidth: '80%'
  },
  bubbleGroupHeader: {
    margin: 0,
    fontSize: 12,
    fontWeight: '400',
    color: '#999',
  },
  senderBubbleWrapper: {
    marginTop: 10,
    marginBottom: 10,
    overflow: 'auto',
    position: 'relative',
  }
};
